import React from "react";
import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/fa';

export default function CKEditorCmp(props) {

    return (
        <>
            <label className="justify-content-start p-0 py-2">{props.label}</label>
            <CKEditor
                id={props.id}
                editor={ClassicEditor}
                data={props.value}
                {...props}
                config={{
                    toolbar: [
                        "undo", "redo", "bold", "italic", 'alignment', 'horizontalline', "blockQuote", "heading", "link", "numberedList", "bulletedList", "insertTable", "tableColumn", "tableRow", "mergeTableCells"
                        // 'heading', '|', 'alignment:left', 'alignment:right', 'alignment:center', 'alignment:justify'
                    ],
                    ui: 'en',
                    language: 'fa',
                    contentsLangDirection: 'rtl'
                }}
                onChange={(event, editor) => {
                    const data = editor.getData();
                    props.onChange(data);
                }}
            />
        </>
    )
}